import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { checkmarkIcon } from '../../icons';

@Component({
    selector: 'app-vehicle-accessories-list',
    template: `
        <h3 class="vehicle-accessories-list__header" *ngIf="listHeaderText">{{listHeaderText}}</h3>

        <ul class="vehicle-accessories-list" *ngIf="currentList.length"
            [ngClass]="{'double-column': currentList.length > 10}">
            <li class="vehicle-accessories-list__item" *ngFor="let text of currentList">
                <i class="list-bullet-icon">${checkmarkIcon}</i> {{text}}
            </li>
        </ul>

        <button *ngIf="showAllButton"
            class="button button--as-link theme-text vehicle-accessories-list__button button--themed"
            (click)="showCompleteAccessoriesList()" [ngSwitch]="showingAll">
            <ng-container *ngSwitchCase="true">{{'new_vehicles.fold_in_list_of_accessories' | translate}}</ng-container>
            <ng-container *ngSwitchCase="false">{{'new_vehicles.fold_out_list_of_accessories' | translate}}</ng-container>
        </button>
    `
})

export class VehicleAccessoriesListComponent implements OnInit {
    @Input() listHeaderText: string;
    @Input() listItems: any[];
    @Input() amountToShow: number;
    @Input() showAllButton: boolean;

    currentList: string[] = [];
    showingAll = false;

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit() {
        if (this.amountToShow === undefined) {
            this.currentList = this.listItems;
            this.showAllButton = false;
        } else {
            this.currentList = this.listItems.slice(0, this.amountToShow);

            if (this.listItems.length <= this.amountToShow && this.showAllButton) {
                this.showAllButton = false;
            }
        }

        this.cdr.markForCheck();
    }

    showCompleteAccessoriesList() {
        if (this.showingAll) {
            this.currentList = this.listItems.slice(0, this.amountToShow);
            this.showingAll = false;
        } else {
            this.currentList = this.listItems;
            this.showingAll = true;
        }
    }
}